import { useEffect, useState } from 'react';

/** Returns a 0..1 value of the scroll position relative to the supplied threshold. */
export function useScrollProgress(threshold = 80): number {
  const [p, setP] = useState(0);
  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const y = window.scrollY || 0;
        setP(Math.max(0, Math.min(1, y / threshold)));
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [threshold]);
  return p;
}
